import React from 'react';
import { SearchAircraft } from '@/features/search';

/**
 * SearchAircraft Page
 * Page wrapper for the SearchAircraft feature component
 */
const SearchAircraftPage = () => {
  return <SearchAircraft />;
};

export default SearchAircraftPage;
